<template>
  <div id="music-player"  v-if="isPlay">
    <div class="paly-p" :style="isPlay ? 'transform: translateY(0);' : 'transform: translateY(75px);'">
      <audio :src="audioUrl" controls canplay ref="audioM" />
      <i class="iconfont icon-guanbi gb" @click="closePlay" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'musicPlayer',
    data() {
      return {
        audioUrl: '',
        isPlay: false,
        token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
      }
    },
    methods: {
      // 关闭播放
      closePlay () {
        this.$refs.audioM.pause()
        this.$set(this, 'audioUrl', '')
        this.$set(this, 'isPlay', false)
      },
      // 开始播放
      async paly (url) {
        const player = document.querySelector('#music-player')
        if (player) {
          const playerF =  player.parentElement;
          playerF.removeChild(player);
        }
        if (url.includes('?')) {
          // 存在参数：替换或添加token
          const urlObj = new URL(url, window.location.origin);
          urlObj.searchParams.set('accesstoken', this.token); // 存在则替换，不存在则添加
          url = urlObj.toString();
        } else {
          // 无参数：直接追加token
          url = `${url}?accesstoken=${this.token}`;
        }
        console.log(url, 'urlurlurlurlurl')
        this.$set(this, 'audioUrl', url)
        this.$set(this, 'isPlay', true)
        await this.$nextTick()
        this.$refs.audioM.play()
      },
    }
  }
</script>

<style lang="scss" scoped>
  #music-player {
    z-index: 2999;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .paly-p {
      width: 100%;
      background-color: #f1f3f4;
      text-align: center;
      transition: 0.3s;
      height: 58px;
      .gb {
        cursor: pointer;
        position: absolute;
        // right: 10%;
        // top: -17px;
        right: 2%;
        top: calc(50% - 10px);
        background-color: #f1f3f4;
        border-radius: 10px;
        font-size: 20px;
      }
    }
  }
</style>
